"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/interopRequireWildcard"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _styledComponentThemes = require("../../_nextgen/packages/styled-component-themes");
var _analytics = require("../analytics");
var _Text = require("../Text");
var Styled = _interopRequireWildcard3(require("./index.styled"));
var themeColors = _interopRequireWildcard3(require("./index.themes"));
var _jsxRuntime = require("react/jsx-runtime");
const Text = (0, _Text.configureText)({
  LexusButton: (0, _component.default)(function () {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../LexusButton"));
    });
  }),
  CountDown: (0, _component.default)(function () {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../CountDown"));
    });
  }),
  DividerLine: (0, _component.default)(function () {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../../modules/DividerLine"));
    });
  }),
  Icon: (0, _component.default)(function () {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("./Icon"));
    });
  }),
  Align: (0, _component.default)(function () {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("./Align"));
    });
  }),
  Accordion: (0, _component.default)(function () {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../AccordionDrawer"));
    });
  }),
  a: (0, _component.default)(function () {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../Link"));
    });
  }),
  Helmet: (0, _component.default)(function () {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("./HelmetProxy"));
    });
  }),
  Drawer: (0, _component.default)(function () {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../../modules/Drawer"));
    });
  }),
  VehicleServiceHistory: (0, _component.default)(function () {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("./VehicleServiceHistory"));
    });
  }),
  FullScreenMediaButton: (0, _component.default)(function () {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../FullScreenMediaButton"));
    });
  }),
  GRContent: (0, _component.default)(function () {
    return Promise.resolve().then(function () {
      return (0, _interopRequireWildcard2.default)(require("../GRContent"));
    });
  }),
  ...Styled.DOM
});
const CopyBlock = function (_ref) {
  let {
    id = "copy-block",
    text,
    bindings,
    allowScripting = false,
    className,
    transparentBackground = false
  } = _ref;
  const blacklistedTags = allowScripting ? [] : ["script", "Helmet"];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.CopyBlock, {
    className: className,
    id: id,
    $transparentBackground: transparentBackground,
    "data-testid": "CopyBlock",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Text, {
      bindings: bindings,
      blacklistedTags: blacklistedTags,
      children: text
    })
  });
};
var _default = exports.default = (0, _analytics.withAnalytics)((0, _styledComponentThemes.withThemes)(CopyBlock, themeColors))({});